import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { isEmpty, find } from 'lodash';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import generalSchema from '../../schemas/generalSchema';
import styles from './general.module.scss';

export default class Contact extends Component {
    constructor(props) {
        super(props);

        this.form = React.createRef();
    }

    findTimeZoneByCountry(country) {
        const timezone = find(this.props.timezones, timezone => {
            if (timezone.value.indexOf(country) !== -1) {
                return true;
            }
        });

        return timezone ? timezone.key : '0';
    }

    matchLanguage() {
        let defaultLanguage = this.form.current.state.values.DefaultLanguage;
        const matchedLanguage = find(this.props.languages, { key: window.navigator.language });

        defaultLanguage = (matchedLanguage && !defaultLanguage) ? matchedLanguage.key : 'en';

        return defaultLanguage;
    }

    componentDidMount() {
        this.form.current.state.values.DefaultLanguage = this.matchLanguage();

        this.props.updateStep(this.form.current.state.values);

        if (!this.form.current.state.values.AbleToComplete) {
            this.form.current.state.values.AbleToComplete = true;

            this.props.updateStep(this.form.current.state.values);
        } else if (this.props.editable) {
            this.form.current.submitForm();
        }
    }

    componentWillUnmount() {
        if (this.props.editable) {
            this.form.current.state.values.Completed = isEmpty(this.form.current.state.errors)
                && !isEmpty(this.form.current.state.touched);

            this.props.updateStep(this.form.current.state.values);
        }
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.fieldsContainer}>
                    <Formik
                        ref={this.form}
                        initialValues={{
                            Key: this.props.formData.key,
                            Completed: this.props.formData.Completed,
                            AbleToComplete: this.props.formData.AbleToComplete,
                            CompanyName: this.props.formData.CompanyName,
                            CompanyContact: this.props.formData.CompanyContact,
                            CompanyPhone: this.props.formData.CompanyPhone,
                            CompanyEmail: this.props.formData.CompanyEmail,
                            AreaCode: this.props.formData.AreaCode,
                            CompanyCountry: this.props.formData.CompanyCountry,
                            CompanyState: this.props.formData.CompanyState,
                            CompanyCity: this.props.formData.CompanyCity,
                            DefaultLanguage: this.props.formData.DefaultLanguage,
                            TimeZone: this.props.formData.TimeZone
                        }}
                        enableReinitialize={true}
                        validationSchema={generalSchema}
                        onSubmit={() => null}
                        render={(props) => (
                            <Form>
                                <div className={styles.row}>
                                    <TextField
                                        type="text"
                                        label={this.props.t('common:COMPANY')}
                                        name="CompanyName"
                                        value={props.values.CompanyName}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyName &&
                                            Boolean(props.errors.CompanyName)
                                        }
                                        helperText={
                                            (
                                                props.touched.CompanyName &&
                                                Boolean(props.errors.CompanyName)
                                            )
                                                ? <span>{this.props.t(`validations:${props.errors.CompanyName}`)}</span>
                                                : ''
                                        }
                                    />
                                    <TextField
                                        type="text"
                                        label={this.props.t('common:CONTACT')}
                                        name="CompanyContact"
                                        value={props.values.CompanyContact}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyContact &&
                                            Boolean(props.errors.CompanyContact)
                                        }
                                        helperText={
                                            (
                                                props.touched.CompanyContact &&
                                                Boolean(props.errors.CompanyContact)
                                            )
                                                ? <span>{this.props.t(`validations:${props.errors.CompanyContact}`)}</span>
                                                : ''
                                        }
                                    />
                                </div>
                                <div className={styles.row}>
                                    <TextField
                                        type="text"
                                        label={this.props.t('common:PHONE')}
                                        name="CompanyPhone"
                                        value={props.values.CompanyPhone}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyPhone &&
                                            Boolean(props.errors.CompanyPhone)
                                        }
                                        helperText={
                                            (
                                                props.touched.CompanyPhone &&
                                                Boolean(props.errors.CompanyPhone)
                                            )
                                                ? <span>{this.props.t('validations:NO_PHONE_AREA_CODE')}</span>
                                                : <span>{this.props.t('validations:NO_PHONE_AREA_CODE')}</span>
                                        }
                                    />
                                    <TextField
                                        type="email"
                                        label={this.props.t('common:EMAIL')}
                                        name="CompanyEmail"
                                        value={props.values.CompanyEmail}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyEmail &&
                                            Boolean(props.errors.CompanyEmail)
                                        }
                                        helperText={
                                            (
                                                props.touched.CompanyEmail &&
                                                Boolean(props.errors.CompanyEmail)
                                            )
                                                ? <span>{this.props.t(`validations:${props.errors.CompanyEmail}`)}</span>
                                                : ''
                                        }
                                    />
                                </div>
                                <div className={styles.row}>
                                    <FormControl
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyCountry &&
                                            Boolean(props.errors.CompanyCountry)
                                        }
                                    >
                                        <InputLabel htmlFor="CompanyCountry">{this.props.t('common:COUNTRY')}</InputLabel>
                                        <Select
                                            value={props.values.CompanyCountry}
                                            onChange={event => {
                                                props.values.TimeZone = this.findTimeZoneByCountry(event.target.value);

                                                props.handleChange(event);
                                            }}
                                            onBlur={event => {
                                                props.values.TimeZone = this.findTimeZoneByCountry(event.target.value);

                                                props.handleBlur(event);
                                            }}
                                            input={<Input name="CompanyCountry" id="CompanyCountry" />}
                                        >
                                            {
                                                this.props.countries.map((country) => (
                                                    <MenuItem key={country.key} value={country.key}>{country.value}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                        {
                                            props.touched.CompanyCountry &&
                                            Boolean(props.errors.CompanyCountry) &&
                                            <FormHelperText>
                                                {this.props.t(`validations:${props.errors.CompanyCountry}`)}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                    <TextField
                                        type="text"
                                        label={this.props.t('common:STATE')}
                                        name="CompanyState"
                                        value={props.values.CompanyState}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyState &&
                                            Boolean(props.errors.CompanyState)
                                        }
                                        helperText={
                                            (
                                                props.touched.CompanyState &&
                                                Boolean(props.errors.CompanyState)
                                            )
                                                ? <span>{this.props.t(`validations:${props.errors.CompanyState}`)}</span>
                                                : ''
                                        }
                                    />
                                </div>
                                <div className={styles.row}>
                                    <TextField
                                        type="text"
                                        label={this.props.t('common:CITY')}
                                        name="CompanyCity"
                                        value={props.values.CompanyCity}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.CompanyCity &&
                                            Boolean(props.errors.CompanyCity)
                                        }
                                        helperText={
                                            (
                                                props.touched.CompanyCity &&
                                                Boolean(props.errors.CompanyCity)
                                            )
                                                ? <span>{this.props.t(`validations:${props.errors.CompanyCity}`)}</span>
                                                : ''
                                        }
                                    />
                                    <TextField
                                        type="number"
                                        label={this.props.t('common:AREA_CODE')}
                                        name="AreaCode"
                                        value={props.values.AreaCode}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.AreaCode &&
                                            Boolean(props.errors.AreaCode)
                                        }
                                        helperText={
                                            (
                                                props.touched.AreaCode && Boolean(props.errors.AreaCode)
                                            )
                                                ? <span>{this.props.t(`validations:${props.errors.AreaCode}`)}</span>
                                                : ''
                                        }
                                    />
                                </div>
                                <div className={styles.row}>
                                    <FormControl
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.DefaultLanguage &&
                                            Boolean(props.errors.DefaultLanguage)
                                        }
                                    >
                                        <InputLabel htmlFor="DefaultLanguage">{this.props.t('common:LANGUAGE')}</InputLabel>
                                        <Select
                                            value={props.values.DefaultLanguage}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            input={<Input name="DefaultLanguage" id="DefaultLanguage" />}
                                        >
                                            {
                                                this.props.languages.map((language) => (
                                                    <MenuItem key={language.key} value={language.key}>{language.value}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                        {
                                            props.touched.DefaultLanguage &&
                                            Boolean(props.errors.DefaultLanguage) &&
                                            <FormHelperText>
                                                {this.props.t(`validations:${props.errors.DefaultLanguage}`)}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                    <FormControl
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.TimeZone &&
                                            Boolean(props.errors.TimeZone)
                                        }
                                    >
                                        <InputLabel htmlFor="TimeZone">{this.props.t('common:TIMEZONE')}</InputLabel>
                                        <Select
                                            value={props.values.TimeZone}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            input={<Input name="TimeZone" id="TimeZone" />}
                                        >
                                            {
                                                this.props.timezones.map((timezone) => (
                                                    <MenuItem key={timezone.key} value={timezone.key}>
                                                        {timezone.value}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                        {
                                            props.touched.TimeZone &&
                                            Boolean(props.errors.TimeZone) &&
                                            <FormHelperText>
                                                {this.props.t(`validations:${props.errors.TimeZone}`)}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    />
                </div>
            </div>
        );
    }
}
